// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"3438721b","301":"b5978bdc","587":"d87d27d1","621":"d7017317","812":"5b74f0d0","958":"1991a545"}[chunkId] + ".chunk.js";
};